var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapacitybuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.59460449 72.59472656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e9edf2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,1.06925153v70.4562235c0,.59053131.47872022,1.06925153,1.06925153,1.06925153h70.45610143c.59053131,0,1.06925153-.47872022,1.06925153-1.06925153V1.06925153c0-.59053131-.47872022-1.06925153-1.06925153-1.06925153H1.06925153C.47872022,0,0,.47872022,0,1.06925153Zm67.19944256,66.52547503H5.39516193c-.21824191,0-.39516193-.17692002-.39516193-.39516193V5.39516193c0-.21824191.17692002-.39516193.39516193-.39516193h61.80428063c.21824191,0,.39516193.17692002.39516193.39516193v61.8044027c0,.21824191-.17692002.39516193-.39516193.39516193Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.1600647,
    y: 47.68987081,
    width: 17.82482069,
    height: 17.98480469,
    rx: 0.97767007,
    ry: 0.97767007
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.38486138,
    y: 47.68987081,
    width: 17.82482069,
    height: 17.98480469,
    rx: 0.97767007,
    ry: 0.97767007
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.60965807,
    y: 47.68987081,
    width: 17.82482069,
    height: 17.98480469,
    rx: 0.97767007,
    ry: 0.97767007
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.38486138,
    y: 27.30509013,
    width: 17.82482069,
    height: 17.98480469,
    rx: 0.97767007,
    ry: 0.97767007
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.60965807,
    y: 27.30509013,
    width: 17.82482069,
    height: 17.98480469,
    rx: 0.97767007,
    ry: 0.97767007
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.60965807,
    y: 6.92030944,
    width: 17.82482069,
    height: 17.98480469,
    rx: 0.97767007,
    ry: 0.97767007
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.62620304,13.6560506h-5.85839247c-.24108563,0-.44358931-.19767726-.44358931-.44358931v-5.87284231c0-.24591205-.19770669-.44361874-.43879232-.44361874h-3.62108137c-.24500386,0-.44361874.19861488-.44361874.44361874v5.87284231c0,.24498761-.1986017.44358931-.44358931.44358931h-5.85839247c-.24498761,0-.44358931.1986017-.44358931.44358931v3.6211108c0,.24108563.19767726.44358931.44358931.44358931h5.85839247c.24498761,0,.44358931.1986017.44358931.44358931v5.85356605c0,.24500386.19861488.44361874.44361874.44361874h3.62108137c.24108563,0,.43879232-.19770669.43879232-.44361874v-5.85353662c0-.24591205.20250369-.44361874.44358931-.44361874h5.85839247c.24397412,0,.44358931-.19961519.44358931-.44358931v-3.6211108c0-.24498761-.1986017-.44358931-.44358931-.44358931Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitybuilding);
export default __webpack_public_path__ + "static/media/capacity building.eb5ea624f6adab96a5db089a8d0846a1.svg";
export { ForwardRef as ReactComponent };